export const searchCouponColumns = [
  {
    type: 'selectInput',
    prop: 'search_value',
    label: '',
    selectKey: 'search_key',
    placeholder: 'Search..',
    width: '120',
    options: [
      { label: 'Coupon No', value: 'coupon_no' },
      { label: 'Coupon Name', value: 'name' },
    ]
  },
  {
    type: 'select',
    prop: 'type',
    label: 'Type',
    placeholder: 'All',
    options: [
      {label:'Flat rate',value: 1},
      {label:'Percentage',value: 2},
    ]
  },
  {
    type: 'select',
    prop: 'valid_sizes',
    label: 'Valid sizes',
    placeholder: 'All',
    options: [
      { label: 'Small', value: 1 },
      { label: 'Medium', value: 2 },
      { label: 'Large', value: 3 },
    ]
  }
]

export const UsageLogColumns = [
  {
    type: 'selectInput',
    prop: 'search_value',
    label: '',
    selectKey: 'search_key',
    placeholder: 'Search..',
    width: '120',
    options: [
      { label: 'Coupon No', value: 'coupon_no' },
    ]
  }
]
